// SPDX-FileCopyrightText: 2023 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import { EvaluateStrategiesAckMessage } from '@tls/sw91-communication/types/com.api_predictor';

export type ModelEvaluationProgressResult = {
  id: string | undefined;
} & EvaluateStrategiesAckMessage;

export function isModelEvaluationProgressResult(arg: any): arg is ModelEvaluationProgressResult {
  return (
    arg?.messageHeader !== undefined &&
    arg?.status !== undefined &&
    arg?.evaluationResult !== undefined &&
    arg?.progress !== undefined &&
    arg?.id !== undefined
  );
}
